import {compose} from "redux";
import {connect} from "react-redux";
import {getSalesActiveCloseSelector} from "../../CalendarPercent/selectors";
import Day from "./Day";
import {getPriceTypesSelector} from "../../../globalState/app/selectros";

let mapStateToProps = (state, props) => {
    return {
        salesActiveClose: getSalesActiveCloseSelector(state),


    }
};


export default compose(connect(mapStateToProps, {}))(Day);

